import { parseNumber } from "@/components/widgets/helpers/FormattingHelpers";

export const getValueToPercents = (
	rawValue: string,
	isPercent: boolean,
): string => {
	if (rawValue === "") return "";

	const parsed = Number(parseNumber(rawValue));
	if (Number.isNaN(parsed)) return "";

	return isPercent ? String(parsed * 100) : String(parsed);
};
